export const Coordinate = {
  DISPLAY: 0,
  NORMALIZED_DISPLAY: 1,
  VIEWPORT: 2,
  NORMALIZED_VIEWPORT: 3,
  VIEW: 4,
  WORLD: 5,
  USERDEFINED: 6,
};

export default {
  Coordinate,
};
